import clsx from 'clsx';

import { Text } from '@/components/Text';

import styles from './NecessaryDocuments.module.scss';

type Props = {
  className?: string;
};

export const NecessaryDocuments = ({ className }: Props) => {
  return (
    <div className={clsx(styles['necessary-documents'], className)}>
      <Text type='h4'>Необхідні документи для нотаріуса</Text>
      <div className={styles['necessary-list']}>
        <div className={styles['necessary-item']}>
          <div className={styles['dot']}></div>
          <div className={styles['necessary-title-wrapper']}>
            <Text style={{ display: 'flex' }} type='p3'>
              Правовстановлюючий документ на земельну ділянку
            </Text>
            <Text color='text-gray' type='p3'>
              (державний акт, свідоцтво про право на спадщину, копія державного акту разом із
              випискою з Державного реєстру речових прав на нерухоме майно)
            </Text>
          </div>
        </div>
        <div className={styles['necessary-item']}>
          <div className={styles['dot']}></div>
          <div className={styles['necessary-title-wrapper']}>
            <Text style={{ display: 'flex' }} type='p3'>
              Паспорт громадянина України або ID-картка
            </Text>
            <Text color='text-gray' type='p3'>
              Паспорт громадянина України (з вклеєними фото у 25 та 45 років), ID-картка з довідкою
              про реєстрацію місця проживання особи
            </Text>
          </div>
        </div>
        <div className={styles['necessary-item']}>
          <div className={styles['dot']}></div>
          <div className={styles['necessary-title-wrapper']}>
            <Text style={{ display: 'flex' }} type='p3'>
              Ідентифікаційний номер
            </Text>
            <Text color='text-gray' type='p3'>
              (Реєстраційний номер облікової картки платника податків (РНОКПП), Індивідуальний
              податковий номер (ІПН), Картка фізичної особи – платника податків, Довідка про
              присвоєння ідентифікаційного номера фізичної особи — платника податків)
            </Text>
          </div>
        </div>
        <div className={styles['necessary-item']}>
          <div className={styles['dot']}></div>
          <div className={styles['necessary-title-wrapper']}>
            <Text style={{ display: 'flex' }} type='p3'>
              Свідоцтво про шлюб або свідоцтво про розлучення
            </Text>
            <Text color='text-gray' type='p3'>
              Свідоцтво про шлюб (якщо продавець одружений) або свідоцтво про розлучення (якщо
              продавець розлучений)
            </Text>
          </div>
        </div>
        <div className={styles['necessary-item']}>
          <div className={styles['dot']}></div>
          <div className={styles['necessary-title-wrapper']}>
            <Text style={{ display: 'flex' }} type='p3'>
              Паспорт та ідентифікаційний номер чоловіка/дружини
            </Text>
            <Text color='text-gray' type='p3'>
              (якщо продавець одружений)
            </Text>
          </div>
        </div>
        <div className={styles['necessary-item']}>
          <div className={styles['dot']}></div>
          <div className={styles['necessary-title-wrapper']}>
            <Text style={{ display: 'flex' }} type='p3'>
              Реквізити банківського рахунку
            </Text>
            <Text color='text-gray' type='p3'>
              Для проведення угоди купівлі-продажу земельної ділянки необхідно мати відкритий
              рахунок у банку і знати його реквізити. Він потрібен для отримання коштів від
              продавця, оскільки оплата за купівлю земельної ділянки може відбуватися лише у
              безготівковій формі.
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};
